import { render, staticRenderFns } from "./ordercuspay.vue?vue&type=template&id=20d448ee"
import script from "./ordercuspay.vue?vue&type=script&lang=js"
export * from "./ordercuspay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports